import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import { MapContext } from '../../context/map';
import useGroup from '../../hooks/use_group';
import useLocation from '../../hooks/use_location';
import useTranslation from '../../hooks/use_translation';
import { getVariantByLanguage } from '../../utils/helpers';
import MapMarker from './map_marker';

const LocationMarkers = ({ location_ids = [] }) => {
	const { map } = useContext(MapContext);
	const { items: groups } = useGroup();
	const { items: locations } = useLocation({
		include_locations: location_ids.length > 0 ? location_ids : null,
	});
	const { language } = useTranslation('component_location_map');
	if (!map) return <></>;

	return (
		<>
			{locations.map((location, index) => {
				let url = `${language != 'sv' ? '/' + language : ''}/mottagningar/`;
				if (!location.latitude || !location.longitude) {
					return;
				}

				const location_variant = getVariantByLanguage(
					language,
					location.location_variants,
				);
				if (!location_variant) return;

				if (location.groups && location.groups[0]) {
					const group = groups.find(
						(value) => value.group_id == location.groups[0],
					);

					const group_variant = getVariantByLanguage(
						'sv',
						group.group_variants,
					);
					if (group_variant) {
						url = `${url}${group_variant.slug}/`;
					}
				}

				if (location_variant.slug) {
					url = `${url}${location_variant.slug}/`;
				}

				return (
					<MapMarker
						address={location.address}
						center={location_ids.length === 1 ? true : false}
						city={location.city}
						excerpt={location_variant.excerpt}
						groups={location.groups}
						image_header={location.fields?.files_header_url_src}
						key={index}
						location_id={location.location_id}
						location_settings={location.location_settings}
						position={{
							latitude: Number(location.latitude),
							longitude: Number(location.longitude),
						}}
						slug={location_variant.slug}
						subtitle={location_variant.subtitle}
						title={location_variant.title}
						url={url}
						zip_code={location.zip_code}
					/>
				);
			})}
		</>
	);
};

LocationMarkers.propTypes = {
	location_ids: PropTypes.arrayOf(PropTypes.number, PropTypes.string),
};

export default LocationMarkers;
